import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { SyllabusQuery } from '@examdojo/category/v2';
import { Entitlement, EntitlementService } from '@examdojo/core/entitlement';
import { StreakQuery, StreakSummaryComponent } from '@examdojo/streak';
import { UserQuery } from '@examdojo/user';
import { IonButton } from '@ionic/angular/standalone';
import { combineLatest, map } from 'rxjs';
import { RootUrlParts } from '../../../app.model';
import { SettingsUrlParts } from '../../../settings/settings.model';
import { UserMarksQuery } from '../../../user/mark/user-marks-query';
import { CourseSelectMenuComponent } from './components/course-select-menu/course-select-menu.component';
import { FreeGradingMenuComponent } from './components/free-grading-menu/free-grading-menu.component';

@Component({
  selector: 'dojo-sidebar-top-panel',
  imports: [IonButton, FreeGradingMenuComponent, MatMenuModule, StreakSummaryComponent, CourseSelectMenuComponent],
  templateUrl: './sidebar-top-panel.component.html',
  styleUrl: './sidebar-top-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarTopPanelComponent {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly syllabusQuery: SyllabusQuery,
    private readonly router: Router,
    private readonly userMarksQuery: UserMarksQuery,
    private readonly streakQuery: StreakQuery,
    private readonly entitlementService: EntitlementService,
  ) {}

  private readonly hasUnlimitedCredits$ = combineLatest([
    this.entitlementService.selectOne(Entitlement.UnlimitedCredits),
    this.userQuery.selectHasRoleOrHigher('CONTRIBUTOR'),
  ]).pipe(map(([hasEntitlement, isContributorOrHigher]) => hasEntitlement || isContributorOrHigher));

  readonly state = connectState({
    user: this.userQuery.active$,
    activeSyllabus: this.syllabusQuery.active$,
    activeCourse: this.userQuery.active$,
    remainingMarks: this.userMarksQuery.remainingMarks$,
    hasUnlimitedCredits: this.hasUnlimitedCredits$,
    streakDaysNumber: this.streakQuery.streakDays$,
  });

  navigateToCourse() {
    this.router.navigate([RootUrlParts.Settings, SettingsUrlParts.Courses]);
  }
}
